import React from "react";
import {
  Card,
  Button,
  Modal,
  MarketingLayout,
  FormField,
  Input,
  Image,
  Layout,
  Cell,
  Heading,
  Loader,
  Box,
  TextButton,
  Dropdown,
  NumberInput,
  SectionHelper,
  Text,
  Radio,
  Checkbox,
  MultiSelect,
  Divider
} from '@wix/design-system';

import { DownloadImport, Add } from '@wix/wix-ui-icons-common';

import dpd from "../../../assets/images/dpd.png";
import austria from "../../../assets/images/austria.png";
import italy from "../../../assets/images/italy.png";
import germany from "../../../assets/images/germany.png";
import luxembourg from "../../../assets/images/luxembourg.png";
import belgium from "../../../assets/images/belgium.png";

// Pays-Bas et Espagne sont identifies par le logo de leur operateur postal
// (PostNL, Correos) plutot que par un drapeau, comme sur l'app Shopify.
// Logos herberges sur le CDN Webflow du Studio : modifiables sans redeploy.
const postnl  = 'https://cdn.prod.website-files.com/64a7e3393036f38e45a4c0cc/6a3906ea184ded6df7c091d4_postnl-3.svg';
const correos = 'https://cdn.prod.website-files.com/64a7e3393036f38e45a4c0cc/6a3906eaf092e143fb022b87_Correos-Logo.png';

// Reseaux postaux locaux proposes en alternative a DPD. Cette table pilote a
// la fois les tags pre-selectionnes, les options du MultiSelect et la liste
// des pays affichee dans l'encart d'explication : ajouter un pays ici suffit.
// Elle doit rester alignee sur `config.dpd_eligibility` (config/application.rb),
// qui decide cote back si l'offre locale est applicable a une commande.
//
// `legacyCodes` : anciens codes encore stockes en base. L'Autriche a longtemps
// ete enregistree sous « AU » — le code ISO de l'Australie — alors que le back
// compare au code pays de la commande, « AT » : le reseau local autrichien ne
// pouvait donc jamais s'appliquer. On accepte l'ancien code en lecture pour ne
// pas faire perdre sa selection au marchand, et « AT » est reecrit en base au
// prochain enregistrement de la configuration.
const LOCAL_OFFER_COUNTRIES = [
  { id: 'DE', key: 'germany',     logo: germany,    width: '70px' },
  { id: 'AT', key: 'austria',     logo: austria,    width: '70px', legacyCodes: ['AU'] },
  { id: 'IT', key: 'italy',       logo: italy,      height: '15px' },
  { id: 'LU', key: 'luxembourg',  logo: luxembourg, height: '15px' },
  { id: 'BE', key: 'belgium',     logo: belgium,    height: '15px' },
  { id: 'NL', key: 'netherlands', logo: postnl,     height: '15px' },
  { id: 'ES', key: 'spain',       logo: correos,    height: '15px' },
];

// Table de correspondance ancien code -> code canonique, derivee de la table
// ci-dessus pour eviter de maintenir la meme information a deux endroits.
const LEGACY_LOCAL_OFFER_CODES = LOCAL_OFFER_COUNTRIES.reduce((acc, country) => {
  (country.legacyCodes || []).forEach((code) => { acc[code] = country.id; });
  return acc;
}, {});

const localOfferLabel = (country) => (
  <div>
    {I18n.t(`configs.back_end.${country.key}`)} <img src={country.logo} width={country.width} height={country.height} />
  </div>
);

import { passCsrfToken } from '../../util/helpers'
import axios from 'axios'

class BackOffice extends React.Component {

  constructor(props) {
    super(props);

    var local_offer = [];
    var config = props.configData;

    if (props.configData.local_offer != "") {
      // Les codes historiques sont remis a leur valeur canonique AVANT d'etre
      // places en state : c'est ce tableau qui sera enregistre, la correction
      // est donc persistee au prochain enregistrement de la configuration.
      if (Array.isArray(props.configData.local_offer)) {
        config = {
          ...props.configData,
          local_offer: props.configData.local_offer.map((code) => LEGACY_LOCAL_OFFER_CODES[code] || code),
        };
      }

      LOCAL_OFFER_COUNTRIES.forEach((country) => {
        const codes = [country.id].concat(country.legacyCodes || []);
        if (codes.some((code) => props.configData.local_offer.includes(code))) {
          local_offer.push({ id: country.id, label: localOfferLabel(country) });
        }
      });
    }

    this.state = {
      config: config,
      selectedLocalOffer: local_offer,
      loadingSaveProcess: false,
      eoriTouched: false,
      eoriError: null
    };
  }

  componentDidMount = () => {
    passCsrfToken(document, axios);
  }

  /* Format EORI attendu : 2 lettres + 9 chiffres (ex. FR123456789). Les espaces
     et la casse sont normalisés, un champ vide n'est pas contrôlé ici. */
  getEoriError = (value) => {
    const eori = (value || '').replace(/\s+/g, '').toUpperCase();

    if (eori === '') {
      return null;
    }

    return /^[A-Z]{2}[0-9]{9}$/.test(eori) ? null : I18n.t('configs.back_end.error_eori_format');
  };

  /* Le contrôle ne se déclenche que si le marchand touche au champ : un EORI
     historique déjà enregistré ne doit pas l'empêcher d'enregistrer le reste. */
  handleChangeEori = (e) => {
    const value = e.target.value;
    this.props.handleUpdateConfig(true);
    this.setState({
      showNotification: false,
      eoriTouched: true,
      eoriError: this.getEoriError(value),
      config: { ...this.state.config, eori: value },
    })
  };

  /* Pour le changement de chaque champ de formulaire */
  handleChange = (e) => {
    this.props.handleUpdateConfig(true);
    this.setState({showNotification: false});
    this.setState({
      config: { ...this.state.config, [e.target.name]: e.target.value },
    })
  };

  /* Pour le changement de chaque champ de formulaire */
  handleChangeRadio = (field, value) => {
    this.props.handleUpdateConfig(true);
    this.setState({showNotification: false});
    this.setState({
      config: { ...this.state.config, [field]: value },
    })
  };
  /* Pour le changement du nombre de jour de préparation */
  handleChangeDays = (value) => {
    this.props.handleUpdateConfig(true);
    this.setState({showNotification: false});
    this.setState({
      config: { ...this.state.config, order_preparation_time: value },
    })
  };

  /* Pourle changement du poids par défaut */
  handleChangeDefaultWeight = (value) => {
    this.props.handleUpdateConfig(true);
    this.setState({showNotification: false});
    this.setState({
      config: { ...this.state.config, default_weight: value },
    })
  };

  /* Pourle changement de la tare */
  handleChangeTare = (value) => {
    this.props.handleUpdateConfig(true);
    this.setState({showNotification: false});
    this.setState({
      config: { ...this.state.config, packing_tare: value },
    })
  };

  /* Pour le changement du HS CODE */
  handleChangeHsCode = (value) => {
    this.props.handleUpdateConfig(true);
    this.setState({showNotification: false});
    this.setState({
      config: { ...this.state.config, default_hs_code: value },
    })
  };

  /* Pour le changement Insurance amount */
  handleChangeInsuranceAmount = (value) => {
    this.props.handleUpdateConfig(true);
    this.setState({showNotification: false});
    this.setState({
      config: { ...this.state.config, amount_to_insurance: value },
    })
  };

  /* Pour le changement Insurance amount */
  handleChangeReturnLifeTime = (value) => {
    this.props.handleUpdateConfig(true);
    this.setState({showNotification: false});
    this.setState({
      config: { ...this.state.config, return_lifetime: value },
    })
  };

  /* Gestion des mises à jour du format d'impression */
  handleSelectLabelFormat = (e) => {
    this.props.handleUpdateConfig(true);
    this.setState({showNotification: false});
    this.setState({
      config: { ...this.state.config, ['label_format']: e.id },
    })
  }

  /* gestion du protocol d'impression */
  handleSelectProtocolPrinter = (e) => {
    this.props.handleUpdateConfig(true);
    this.setState({showNotification: false});
    this.setState({
      config: { ...this.state.config, ['usb_protocole']: e.id },
    })
  }

  handleChangeFont = (e) => {
    this.props.handleUpdateConfig(true);
    this.setState({showNotification: false});
    this.setState({
      config: { ...this.state.config, ['widget_font']: e.id },
    })
    $('#widget_font_text h1').css("font-family", e.id);
  }

  handleChangeColor = (field, value) => {
    this.props.handleUpdateConfig(true);
    this.setState({showNotification: false});
    this.setState({
      config: { ...this.state.config, [field]: value },
    })
  }

  /* Modification des local Offer */
  handleOnSelectLocalOffer = (e) => {
    this.props.handleUpdateConfig(true);
    this.setState({showNotification: false});
    this.setState({selectedLocalOffer: [...this.state.selectedLocalOffer, {id: e.id, label: e.value }]});
    this.setState({config: { ...this.state.config, ['local_offer']: [...this.state.config.local_offer, e.id ]}});
  }

  handleOnRemoveLocalOffer = (offerId) => {
    this.props.handleUpdateConfig(true);
    this.setState({showNotification: false});
    this.setState({selectedLocalOffer: this.state.selectedLocalOffer.filter((currLocalOffer) => currLocalOffer.id !== offerId)});
    this.setState({config: { ...this.state.config, ['local_offer']: this.state.config.local_offer.filter((currLocalOffer) => currLocalOffer !== offerId)}});
    console.log(this.state.selectedLocalOffer);
  }

  /* Submit FORM */
  handleSubmit = () => {
    /* Saisie EORI invalide : inutile d'appeler le serveur, il la refusera */
    if (this.state.eoriTouched && this.state.eoriError) {
      this.props.toggleToast(this.state.eoriError, true);
      return;
    }

    this.setState({showNotification: false});
    this.setState({ loadingSaveProcess: true });

    axios({
    url: this.state.config.id ? '/configs/' + this.state.config.id : '/configs',
    method: this.state.config.id ? 'patch' : 'post',
    data: {
      config: this.state.config,
      instance_id: this.props.shop.instance_id
    },
    }).then(result => {
      if (result.data.success == true) {
        var data = result.data;
        data.config.local_offer = Object.keys(JSON.parse(data.config.local_offer));
        this.setState({ config: data.config });
        this.props.childChange(data.config);
        this.setState({loadingSaveProcess: false});
        //We update general props
        this.props.handleUpdateConfig(false);
        this.props.toggleToast(I18n.t('configs.save_success'), false);
      } else {
        this.setState({loadingSaveProcess: false});
        /* Le serveur a refusé l'EORI : on le signale sous le champ concerné */
        if (result.data.errors && result.data.errors.eori) {
          this.setState({eoriError: I18n.t('configs.back_end.error_eori_format')});
          this.props.toggleToast(I18n.t('configs.back_end.error_eori_format'), true);
        } else {
          this.props.toggleToast(I18n.t('configs.save_error'), true);
        }
      }
    }).catch(error => {
      console.log(error);
      this.setState({loadingSaveProcess: false});
      this.props.toggleToast(I18n.t('configs.save_error'), true);
    });
  };

  // Ouvre la page de diagnostic QZ Tray dans un onglet top-level : l'iframe Wix ne
  // délègue pas `local-network-access`, la websocket QZ (localhost) n'y est donc
  // joignable qu'hors iframe (même contrainte que la fenêtre d'impression).
  testQzKit = () => {
    let url = '/qz-test';
    try {
      const locale = window.I18n && window.I18n.locale;
      if (locale) url += '?locale=' + encodeURIComponent(String(locale).slice(0, 2));
    } catch (e) {}
    window.open(url, 'colissimo_qz_test');
  }

  downloadFile = () => {
    axios({
      method: 'post',
      url: '/download-fmt-file',
    }).then(result => {
        if (result.data.success == true) {
            const FileDownload = require('js-file-download');
            FileDownload(result.data.content_fmt, 'shopify.fmt');
        }
    }).catch(error => {
        console.log(error);
    });
  }

  render() {
    const {
      config,
      loadingSaveProcess,
      selectedLocalOffer
    } = this.state;


    console.log(config);
    console.log(selectedLocalOffer);

    const descriptionSection = (
        <Card>
          <MarketingLayout
            title={I18n.t('configs.back_end.title_parameters')}
            description={`${I18n.t('configs.view_video')} ${I18n.t('configs.step3_video')}`}
            actions={<TextButton as="a" href="https://www.loom.com/share/e1733077280f4b1282f8f6ee3dd870d8?sid=9515cdea-ee6d-475b-945a-43c9e7890efd" target="_blank">{I18n.t('configs.view_video_button')}</TextButton>}
            size="tiny"
            image={
              <Box width="100%">
                <Image src="https://cdn.prod.website-files.com/64a7e3393036f38e45a4c0cc/69a9970f89c43a367c817966_video_ecran_113.svg" width="70%" height="70%" transparent />
              </Box>
            }
          />
        </Card>
    );


    return (
      <div>
        <Modal
          screen="desktop"
          isOpen={loadingSaveProcess}
        >
          <Loader size="large" />
        </Modal>
        {/* URL WIDGET */}
        <Layout cols={12}>
          <Cell span={4}>
            {descriptionSection}
          </Cell>
          <Cell span={8}>
            <Card>
              <Card.Content>
                <Cell>
                  <FormField
                    label={I18n.t('configs.back_end.label_preparation_time')}
                    infoContent={I18n.t('configs.back_end.help_preparation_time')}
                  >
                    <NumberInput prefix={<Input.Affix>{I18n.t('configs.back_end.days')}</Input.Affix>} value={`${config.order_preparation_time}`} onChange={(value) => this.handleChangeDays(value)} />
                  </FormField>
                  <br/>
                  <Heading size="large">{I18n.t('configs.back_end.print_label')}</Heading>
                  <br/>
                  <FormField
                  label={I18n.t('configs.back_end.label_generate_label_shopify')}
                  >
                      <Radio
                      alignItems="top"
                      checked={config.generate_label_shopify === true}
                      onChange={() => this.handleChangeRadio('generate_label_shopify', true)}
                      label={
                        <Cell>
                          <Text size="small" secondary>
                            {I18n.t('configs.back_end.generate_label_shopify')}
                          </Text>
                          <br/>
                          {config.generate_label_shopify === true &&
                            <Box marginTop="6px" width="100%">
                              <FormField
                                  label={I18n.t('configs.back_end.label_label_format')}
                              >
                                <Dropdown
                                  name="label_format"
                                  options={[
                                    {value: "PDF A4 300dpi", id: "PDF_A4_300dpi"},
                                    {value: "PDF 10x15 300dpi", id: "PDF_10x15_300dpi"},
                                    {value: "ZPL 10x15 203dpi", id: "ZPL_10x15_203dpi"},
                                    {value: "ZPL 10x15 300dpi", id: "ZPL_10x15_300dpi"},
                                    {value: "DPL 10x15 203dpi", id: "DPL_10x15_203dpi"},
                                    {value: "DPL 10x15 300dpi", id: "DPL_10x15_300dpi"},
                                  ]}
                                  onSelect={this.handleSelectLabelFormat}
                                  selectedId={config.label_format !== null && config.label_format ? config.label_format : 'PDF_A4_300dpi'}
                                />
                              </FormField>
                            </Box>
                          }
                        </Cell>
                      }
                      />
                      <br/>
                      <Radio
                      alignItems="top"
                      checked={config.generate_label_shopify === false}
                      onChange={() => this.handleChangeRadio('generate_label_shopify', false)}
                      label={
                        <Cell>
                          <Text size="small" secondary>
                            {I18n.t('configs.back_end.generate_label_coliship')}
                          </Text>
                          <br/>
                          {config.generate_label_shopify === false &&
                            <Box marginTop="6px" width="100%">
                              <SectionHelper fullWidth appearance="standard" title={I18n.t('configs.back_end.configuration_coliship')}>
                                <Text size="small">
                                  {I18n.t('configs.back_end.coliship_message')}
                                  <br/>
                                </Text>
                                <br/>
                                <Button onClick={(e) => this.downloadFile()} size="tiny" prefixIcon={<DownloadImport />}>
                                  {I18n.t('configs.back_end.download_fmt')}
                                </Button>
                              </SectionHelper>
                            </Box>
                          }
                        </Cell>
                      }
                      />
                  </FormField>
                  <br/>
                  <FormField>
                      <Checkbox
                        checked={config.notify_customer === true}
                        onChange={() => this.handleChangeRadio('notify_customer', !config.notify_customer)}
                      >
                        {I18n.t('configs.back_end.notify_customer')}
                      </Checkbox>
                      <br/>
                      <Text size="tiny">{I18n.t('configs.back_end.help_notify_customer')}</Text>
                  </FormField>
                  {/*<br/>
                  <FormField>
                      <Checkbox
                        checked={config.picking_after_label === true}
                        onChange={() => this.handleChangeRadio('picking_after_label', !config.picking_after_label)}
                      >
                        {I18n.t('configs.back_end.picking_after_label')}
                      </Checkbox>
                      <br/>
                      <Text size="tiny">{I18n.t('configs.back_end.help_picking_after_label')}</Text>
                  </FormField>*/}
                  <br/>
                  <Heading size="large">{I18n.t('configs.back_end.thermal_printer_title')}</Heading>
                  <br/>
                  <FormField
                  label={I18n.t('configs.back_end.thermal_printer_label')}
                  >
                    <Radio
                    alignItems="top"
                    checked={config.use_thermal_printer === true}
                    onChange={() => this.handleChangeRadio('use_thermal_printer', true)}
                    label={
                        <Cell>
                          <Text size="small" secondary>
                            {I18n.t('configs.back_end.use_thermal_printer_yes')}
                          </Text>
                          <br/>
                          {config.use_thermal_printer === true &&
                            <Cell>
                              <Box marginTop="6px" width="100%">
                                <SectionHelper fullWidth appearance="standard" title={I18n.t('configs.back_end.configuration_thermal_printer')}>
                                    <Text size="small">
                                        {I18n.t('configs.back_end.thermal_printer_format_step1')}
                                        <br/><br/>
                                        {I18n.t('configs.back_end.thermal_printer_format_step2')}
                                        <br/>
                                        <a href='https://qz.io/download/' target='_blank'>{I18n.t('configs.back_end.download_kit')}</a>
                                        <br/>
                                        <a href='https://youtu.be/H6lK7FUN9Wc' target='_blank'>{I18n.t('configs.back_end.thermal_printer_video_windows')}</a>
                                        <br/>
                                        <a href='https://youtu.be/6Brw1rzcKF8' target='_blank'>{I18n.t('configs.back_end.thermal_printer_video_mac')}</a>
                                    </Text>
                                    <Box marginTop="12px">
                                      <Button size="tiny" priority="secondary" onClick={() => this.testQzKit()}>
                                        {I18n.t('configs.back_end.test_kit')}
                                      </Button>
                                    </Box>
                                </SectionHelper>
                              </Box>
                              <>
                              <Box marginTop="6px" width="100%">
                                <FormField
                                    label={I18n.t('configs.back_end.thermal_printer_port_label')}
                                >
                                  <Radio
                                    alignItems="top"
                                    checked={config.thermal_printer_protocol === 'USB'}
                                    onChange={() => this.handleChangeRadio('thermal_printer_protocol', 'USB')}
                                    label={
                                      <Cell>
                                        <Text size="small" secondary>
                                          {I18n.t('configs.back_end.thermal_printer_usb')}
                                        </Text>
                                        <br/>
                                        {config.thermal_printer_protocol === 'USB' &&
                                          <Box marginTop="6px" width="100%">
                                            <FormField
                                                label={I18n.t('configs.back_end.thermal_printer_protocole_label')}
                                            >
                                              <Dropdown
                                                name="usb_protocole"
                                                options={[
                                                  {value: "DATAMAX", id: "DATAMAX"},
                                                  {value: "INTERMEC", id: "INTERMEC"},
                                                  {value: "ZEBRA", id: "ZEBRA"},
                                                  {value: "AUTRE (Munbyn, Vevor, Dymo 4 XL, Phomemo, Brother...)", id: "MUNBYN"},
                                                ]}
                                                onSelect={this.handleSelectProtocolPrinter}
                                                selectedId={config.usb_protocole !== null && config.usb_protocole ? config.usb_protocole : 'DATAMAX'}
                                              />
                                            </FormField>
                                          </Box>
                                        }
                                      </Cell>
                                    }
                                  />
                                  <br/>
                                  <Radio
                                    alignItems="top"
                                    checked={config.thermal_printer_protocol === 'ETHERNET'}
                                    onChange={() => this.handleChangeRadio('thermal_printer_protocol', 'ETHERNET')}
                                    label={
                                      <Cell>
                                        <Text size="small" secondary>
                                          {I18n.t('configs.back_end.thermal_printer_ethernet')}
                                        </Text>
                                        <br/>
                                        {config.thermal_printer_protocol === 'ETHERNET' &&
                                          <Box marginTop="6px" width="100%">
                                            <FormField
                                              label={I18n.t('configs.back_end.thermal_printer_ip_label')}
                                            >
                                              <Input
                                                type="text"
                                                name="printer_ip_address"
                                                value={config.printer_ip_address}
                                                onChange={this.handleChange}
                                                placeholder="127.0.0.1"
                                              />
                                            </FormField>
                                          </Box>
                                        }
                                      </Cell>
                                    }
                                  />
                                </FormField>
                              </Box>
                              <br/>
                              <Box marginTop="6px" width="100%">
                                <FormField>
                                  <Checkbox
                                    checked={config.generate_and_print === true}
                                    onChange={() => this.handleChangeRadio('generate_and_print', !config.generate_and_print)}
                                  >
                                    {I18n.t('configs.back_end.generate_and_print')}
                                  </Checkbox>
                                  <br/>
                                  <Text size="tiny">{I18n.t('configs.back_end.help_generate_and_print')}</Text>
                                </FormField>
                              </Box>
                              </>
                            </Cell>
                          }
                        </Cell>
                      }
                    />
                    <br/>
                    <Radio
                    alignItems="top"
                    checked={config.use_thermal_printer === false}
                    onChange={() => this.handleChangeRadio('use_thermal_printer', false)}
                    label={
                      <Cell>
                        <Text size="small" secondary>
                          {I18n.t('configs.back_end.use_thermal_printer_no')}
                        </Text>
                      </Cell>
                    }
                    />
                  </FormField>
                  <br/>
                  <Heading size="large">{I18n.t('configs.back_end.weight_title_options')}</Heading>
                  <br/>
                  <FormField
                    label={I18n.t('configs.back_end.label_default_weight')}
                    infoContent={I18n.t('configs.back_end.help_default_weight')}
                  >
                    <NumberInput placeholder={I18n.t('configs.back_end.placeholder_default_weight')} value={`${config.default_weight !== null && config.default_weight ? config.default_weight : 1000}`} onChange={(value) => this.handleChangeDefaultWeight(value)} />
                    <Text size="tiny">{I18n.t('configs.back_end.help_default_weight')}</Text>
                  </FormField>
                  <br/>
                  <FormField
                    label={I18n.t('configs.back_end.label_packing_tare')}
                    infoContent={I18n.t('configs.back_end.help_packing_tare')}
                  >
                    <NumberInput placeholder={I18n.t('configs.back_end.placeholder_packing_tare')} value={`${config.packing_tare !== null && config.packing_tare ? config.packing_tare : 0}`} onChange={(value) => this.handleChangeTare(value)} />
                    <Text size="tiny">{I18n.t('configs.back_end.help_packing_tare')}</Text>
                  </FormField>
                  <br/>
                  <Heading size="large">{I18n.t('configs.back_end.title_dom_tom')}</Heading>
                  <br/>
                  <FormField>
                    <Checkbox
                        checked={config.colissimo_eco === true}
                        onChange={() => this.handleChangeRadio('colissimo_eco', !config.colissimo_eco)}
                    >
                      {I18n.t('configs.back_end.colissimo_eco')}
                    </Checkbox>
                    <br/>
                    <Text size="tiny">{I18n.t('configs.back_end.help_colissimo_eco')}</Text>
                  </FormField>
                  <br/>
                  <Heading size="large">{I18n.t('configs.back_end.send_worldwide')}</Heading>
                  <br/>
                  <Box marginTop="6px" width="100%">
                    <SectionHelper fullWidth appearance="warning" title={I18n.t('configs.back_end.warning_send_worldwide')}>
                      <Text listStyle="circle" size="small">
                        <ul>
                          <li>{I18n.t('configs.back_end.warning_send_worldwide_list1')}</li>
                          <li>{I18n.t('configs.back_end.warning_send_worldwide_list2')}</li>
                        </ul>
                      </Text>
                    </SectionHelper>
                  </Box>
                  <br/>
                  <FormField
                    label={I18n.t('configs.back_end.label_default_hs_code')}
                    infoContent={I18n.t('configs.back_end.help_default_hs_code')}
                  >
                    <NumberInput placeholder={I18n.t('configs.back_end.placeholder_default_hs_code')} value={`${config.default_hs_code!== null && config.default_hs_code ? config.default_hs_code : ''}`} onChange={(value) => this.handleChangeHsCode(value)} />
                    <Text size="tiny">{I18n.t('configs.back_end.help_default_hs_code')}</Text>
                  </FormField>
                  <br/>
                  <FormField
                    label={I18n.t('configs.back_end.label_eori')}
                  >
                    <Input
                      type="text"
                      name="eori"
                      value={config.eori}
                      onChange={this.handleChangeEori}
                      placeholder={I18n.t('configs.back_end.label_eori_placeholder')}
                      status={this.state.eoriError ? 'error' : undefined}
                      statusMessage={this.state.eoriError ? this.state.eoriError : undefined}
                    />
                    <Text size="tiny">{I18n.t('configs.back_end.help_eori')}</Text>
                  </FormField>
                  <br/>
                  <Box marginTop="6px" width="100%">
                    <SectionHelper fullWidth appearance="danger" title={I18n.t('configs.back_end.change_international_offer')}>
                      <Text size="small">
                        {I18n.t('configs.back_end.text_international_offer')}
                        </Text>
                      <Text listStyle="circle" size="small">
                        {I18n.t('configs.back_end.text_international_offer2')}
                        <ul>
                          {LOCAL_OFFER_COUNTRIES.map((country) => (
                            <li key={country.id}>{I18n.t(`configs.back_end.${country.key}`)}</li>
                          ))}
                        </ul>
                      </Text>
                      <Text size="small">
                        <b>{I18n.t('configs.back_end.text_international_offer3')} <img src={dpd} width="40px" /></b>
                      </Text>
                      <br/>
                      <Text size="small">
                        {I18n.t('configs.back_end.text_international_offer4')}
                      </Text>
                    </SectionHelper>
                  </Box>
                  <br/>
                  <FormField
                    label={I18n.t('configs.back_end.change_offer_choicelist_title')}
                  >
                    <MultiSelect
                      tags={selectedLocalOffer}
                      options={LOCAL_OFFER_COUNTRIES.map((country) => (
                        { id: country.id, value: localOfferLabel(country) }
                      ))}
                      customSuffix={
                        <Box>
                          <TextButton prefixIcon={<Add />}>{I18n.t('configs.back_end.choose_postal_network')}</TextButton>
                        </Box>
                      }
                      onSelect={this.handleOnSelectLocalOffer}
                      onRemoveTag={this.handleOnRemoveLocalOffer}
                    />
                  </FormField>
                </Cell>
              </Card.Content>
            </Card>
          </Cell>
        </Layout>
        <Divider />
        {/* FOMRULAIRE D'ADRESSE */}
        <Layout cols={12}>
          <Cell span={4}>
          <Card>
            <MarketingLayout
              title={I18n.t('configs.back_end.title_advanced_parameters')}
              description={I18n.t('configs.back_end.help_advanced_parameters')}
              size="tiny"
            />
          </Card>
          </Cell>
          <Cell span={8}>
            <Card>
              <Card.Content>
                <Cell>
                  <Heading size="large">{I18n.t('configs.back_end.title_synchronize')}</Heading>
                  <br/>
                  <FormField>
                    <Checkbox
                        checked={config.sychronize_no_colissimo_order === true}
                        onChange={() => this.handleChangeRadio('sychronize_no_colissimo_order', !config.sychronize_no_colissimo_order)}
                    >
                      {I18n.t('configs.back_end.synchronize_no_colissimo_order_label')}
                    </Checkbox>
                    <br/>
                    <Text size="tiny">{I18n.t('configs.back_end.help_synchronize_no_colissimo_order_label')}</Text>
                  </FormField>
                  <br/>
                  <Heading size="large">{I18n.t('configs.back_end.title_insure')}</Heading>
                  <br/>
                  <FormField>
                    <Checkbox
                        checked={config.insure_shipments === true}
                        onChange={() => this.handleChangeRadio('insure_shipments', !config.insure_shipments)}
                    >
                      {I18n.t('configs.back_end.insure_shipments')}
                    </Checkbox>
                    <br/>
                    <Text size="tiny">{I18n.t('configs.back_end.help_insure_shipments')}</Text>
                  </FormField>
                  <br/>
                  <FormField
                    label={I18n.t('configs.back_end.label_amount_to_insurance')}
                    infoContent={I18n.t('configs.back_end.help_amount_to_insurance')}
                  >
                    <NumberInput value={`${config.amount_to_insurance!== null && config.amount_to_insurance ? config.amount_to_insurance : ''}`} onChange={(value) => this.handleChangeInsuranceAmount(value)} />
                    <Text size="tiny">{I18n.t('configs.back_end.help_amount_to_insurance')}</Text>
                  </FormField>
                  <br/>
                  <Heading size="large">{I18n.t('configs.back_end.title_return')}</Heading>
                  <br/>
                  <FormField
                  label={I18n.t('configs.back_end.label_enable_return')}
                  >
                    <Radio
                      alignItems="top"
                      checked={config.enable_return === true}
                      onChange={() => this.handleChangeRadio('enable_return', true)}
                      label={
                        <Cell>
                          <Text size="small" secondary>
                            {I18n.t('configs.back_end.label_yes')}
                          </Text>
                          <br/>
                          {config.enable_return === true &&
                            <Cell>
                              <Box marginTop="SP2" width="100%" direction="vertical">
                                <Box>
                                <Checkbox
                                    checked={config.auto_print_return_label === true}
                                    onChange={() => this.handleChangeRadio('auto_print_return_label', !config.auto_print_return_label)}
                                >
                                  {I18n.t('configs.back_end.auto_print_return_label')}
                                </Checkbox>
                                </Box>
                                <Box>
                                  <Text size="tiny">{I18n.t('configs.back_end.help_auto_print_return_label')}</Text>
                                </Box>
                              </Box>
                              <Box marginTop="SP2" width="100%" direction="vertical">
                                <Checkbox
                                    checked={config.display_return_label_customer === true}
                                    onChange={() => this.handleChangeRadio('display_return_label_customer', !config.display_return_label_customer)}
                                >
                                  {I18n.t('configs.back_end.display_return_label_customer')}
                                </Checkbox>
                              </Box>
                              <Box marginTop="SP2" width="100%" direction="vertical">
                                <Box>
                                  <Checkbox
                                      checked={config.allow_customer_generate_return === true}
                                      onChange={() => this.handleChangeRadio('allow_customer_generate_return', !config.allow_customer_generate_return)}
                                  >
                                    {I18n.t('configs.back_end.allow_customer_generate_return_label')}
                                  </Checkbox>
                                </Box>
                                <Box>
                                  <Text size="tiny">{I18n.t('configs.back_end.help_allow_customer_generate_return_label')}</Text>
                                </Box>
                              </Box>
                              <Box marginTop="SP2" width="100%" direction="vertical">
                                <Box>
                                  <Checkbox
                                      checked={config.generate_return_only_for_france === true}
                                      onChange={() => this.handleChangeRadio('generate_return_only_for_france', !config.generate_return_only_for_france)}
                                  >
                                    {I18n.t('configs.back_end.generate_return_only_for_france_label')}
                                  </Checkbox>
                                </Box>
                                <Box>
                                  <Text size="tiny">{I18n.t('configs.back_end.help_generate_return_only_for_france_label')}</Text>
                                </Box>
                              </Box>
                              <Box marginTop="SP2" width="100%" direction="vertical">
                                <FormField
                                  label={I18n.t('configs.back_end.label_return_lifetime')}
                                  infoContent={I18n.t('configs.back_end.help_return_lifetime')}
                                >
                                  <NumberInput value={`${config.return_lifetime!== null && config.return_lifetime ? config.return_lifetime : 20}`} onChange={(value) => this.handleChangeReturnLifeTime(value)} />
                                  <Text size="tiny">{I18n.t('configs.back_end.help_return_lifetime')}</Text>
                                </FormField>
                              </Box>
                              <Box marginTop="SP2" width="100%" direction="vertical">
                                <Box>
                                  <Checkbox
                                      checked={config.send_return_notification === true}
                                      onChange={() => this.handleChangeRadio('send_return_notification', !config.send_return_notification)}
                                  >
                                    {I18n.t('configs.back_end.send_return_notification_label')}
                                  </Checkbox>
                                </Box>
                                <Box>
                                  <Text size="tiny">{I18n.t('configs.back_end.help_send_return_notification_label')}</Text>
                                </Box>
                              </Box>
                              <Box marginTop="SP2" width="100%" direction="vertical">
                                <Checkbox
                                    checked={config.enable_mailbox_return === true}
                                    onChange={() => this.handleChangeRadio('enable_mailbox_return', !config.enable_mailbox_return)}
                                >
                                  {I18n.t('configs.back_end.enable_mailbox_return')}
                                </Checkbox>
                                <br/>
                              </Box>
                            </Cell>
                          }
                        </Cell>
                      }
                    />
                    <br/>
                    <Radio
                      alignItems="top"
                      checked={config.enable_return === false}
                      onChange={() => this.handleChangeRadio('enable_return', false)}
                      label={
                        <Cell>
                          <Text size="small" secondary>
                            {I18n.t('configs.back_end.label_no')}
                          </Text>
                        </Cell>
                      }
                      />
                  </FormField>
                </Cell>
              </Card.Content>
            </Card>
          </Cell>
        </Layout>
      </div>
    );
  }
}

export default BackOffice
